var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 34.5,
    fill: "#FFF8FB",
    stroke: "#FFD8E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48L26.7 38.9L43.8 21.8C44.6 21 45.9 21 46.7 21.8L50.2 25.3C51 26.1 51 27.4 50.2 28.2L33.1 45.3L24 48Z",
    stroke: "#FF2775",
    strokeWidth: 2.1,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 25.2L46.8 31.5",
    stroke: "#FF2775",
    strokeWidth: 2.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 53H52",
    stroke: "#FF2775",
    strokeWidth: 2.1,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDesign);
export default __webpack_public_path__ + "static/media/icon-design.3d0b8b6e2a5536c3b1abd6011781ccdd.svg";
export { ForwardRef as ReactComponent };